<template>
	<div class="animated fadeIn">
		<AccountDetailComponent
			v-bind:accountSelected="accountSelected"
			v-bind:loading="loading">
		</AccountDetailComponent>

		<b-row class="justify-content-center">
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6" class="font-weight-bold">
								Detalle Viático
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small></b-spinner>
								</div>
							</b-col>
						</b-row>
					</template>
					<b-card-body>
						<b-row class="justify-content-start">
							<b-col md="4" lg="3">
								<h6><span class="text-info">Número: </span> {{ travelExpense.Name }}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6>
									<span class="text-info">Fecha de Creación: </span>
									{{ travelExpense.CreatedOn|dateFormatFull }}
								</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info"># Caso: </span> {{ travelExpense.IncidentNumber }}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Caso: </span> {{ travelExpense.Incident }}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info"># Valoración: </span> {{ travelExpense.OpportunityNumber }}
								</h6>
							</b-col>
							<b-col md="8" lg="9">
								<h6><span class="text-info">Valoración: </span> {{ travelExpense.Opportunity }}</h6>
							</b-col>
						</b-row>

						<h5 class="text-info border-bottom border-info mt-2">Ruta</h5>
						<b-row class="mb-2">
							<b-col md="4" lg="3">
								<h6><span class="text-info">Punto de Partida: </span> SPC</h6>
							</b-col>
							<b-col md="6" lg="6">
								<h6><span class="text-info">Destino: </span> {{ travelExpense.Province }} -
									{{ travelExpense.Canton }} - {{ travelExpense.Location }}</h6>
							</b-col>
						</b-row>

						<h5 class="text-info border-bottom border-info mt-2">Tiempos y Distancias</h5>
						<b-row class="mb-2">
							<b-col md="4" lg="3">
								<h6><span class="text-info">Tiempo Traslado (Horas): </span>
									{{ travelExpense.TransferTime }}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Distancia (KM): </span> {{ travelExpense.Distance }}</h6>
							</b-col>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Tipo GAM: </span> {{ travelExpense.GAMType }}</h6>
							</b-col>
						</b-row>

						<h5 class="text-info border-bottom border-info">Totales</h5>
						<b-row class="justify-content-start">
							<b-col md="4" lg="3">
								<h6><span class="text-info">Total Combustible USD: </span> {{
										travelExpense.TotalGasUSD| currency(
											configSymbolUSD, configSeparator, configFractionCount,configFractionSeparator, configSymbolPosition, configSymbolSpacing
											)
									}}</h6>
							</b-col>
							<!--<b-col md="4" lg="3">
								<h6><span class="text-info">Total Combustible CRC: </span> {{
										travelExpense.TotalGasCRC| currency(
											configSymbolCRC, configSeparator, configFractionCount,configFractionSeparator, configSymbolPosition, configSymbolSpacing
											)
									}}</h6>
							</b-col>-->
							<b-col md="4" lg="3">
								<h6><span class="text-info">Total Alimentación USD: </span> {{
										travelExpense.TotalFoodUSD| currency(
											configSymbolUSD, configSeparator, configFractionCount,configFractionSeparator, configSymbolPosition, configSymbolSpacing
											)
									}}</h6>
							</b-col>
							<!--<b-col md="4" lg="3">
								<h6><span class="text-info">Total Alimentación CRC: </span> {{
										travelExpense.TotalFoodCRC| currency(
											configSymbolCRC, configSeparator, configFractionCount,configFractionSeparator, configSymbolPosition, configSymbolSpacing
											)
									}}</h6>
							</b-col>-->
							<b-col md="4" lg="3">
								<h6><span class="text-info">Total Hospedaje USD: </span> {{
										travelExpense.TotalHotelUSD| currency(
											configSymbolUSD, configSeparator, configFractionCount,configFractionSeparator, configSymbolPosition, configSymbolSpacing
											)
									}}</h6>
							</b-col>
							<!--<b-col md="4" lg="3">
								<h6><span class="text-info">Total Hospedaje CRC: </span> {{
										travelExpense.TotalHotelCRC| currency(
											configSymbolCRC, configSeparator, configFractionCount,configFractionSeparator, configSymbolPosition, configSymbolSpacing
											)
									}}</h6>
							</b-col>-->
							<b-col md="4" lg="3">
								<h6><span class="text-info">Total Viáticos USD: </span> {{
										travelExpense.TotalUSD| currency(
											configSymbolUSD, configSeparator, configFractionCount,configFractionSeparator, configSymbolPosition, configSymbolSpacing
											)
									}}</h6>
							</b-col>
							<!--<b-col md="4" lg="3">
								<h6><span class="text-info">Total Viáticos CRC: </span> {{
										travelExpense.TotalCRC| currency(
											configSymbolCRC, configSeparator, configFractionCount,configFractionSeparator, configSymbolPosition, configSymbolSpacing
											)
									}}</h6>
							</b-col>-->
						</b-row>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>

		<GoBackComponent></GoBackComponent>
	</div>
</template>

<script>
import AccountDetailComponent from "@/components/AccountDetailComponent";
import GoBackComponent from "@/components/GoBackComponent";
import {mapActions, mapState} from "vuex";

export default {
	name: "TravelExpenseDetail",
	components: {
		AccountDetailComponent,
		GoBackComponent,
	},
	data: function () {
		return {
			loading: false,
			travelExpense: '',
			configSeparator: '.',
			configFractionCount: 2,
			configFractionSeparator: ',',
			configSymbolPosition: 'front',
			configSymbolSpacing: false,
			configSymbolUSD: '$',
			configSymbolCRC: '₡',
		}
	},
	mounted() {
		if (this.accountSelected !== '') {
			this.loading = true;
			const travelExpenseId = this.$route.params.id;

			this.getTravelExpenseDetail(travelExpenseId)
				.then((travelExpense) => {
					this.travelExpense = travelExpense;
				})
				.catch((err) => {
					this.loading = false;
					console.error(err);
				})
				.finally(() => {
					this.loading = false;
				})

		} else {
			this.$router.push('/accounts/');
		}
	},
	methods: {
		...mapActions([
			'getTravelExpenseDetail'
		])
	},
	computed: {
		...mapState({
			accountSelected: state => state.accountSelected
		})
	}
}
</script>

<style scoped>

</style>
